<template>
    <div class="filter-container">
        <div class="label">{{ $t('bills.filter_by') }}</div>

        <div class="filter-items">
            <img class="filter-icon" src="../../../../../public/img/user_icon.svg" />

            <v-autocomplete v-if="dates" :items="Object.values(customers)" v-model="currentFilters.customers" class="select">
                <template slot="selection" slot-scope="data">{{ $t(data.item) }}</template>
                <template slot="item" slot-scope="data">{{ $t(data.item) }}</template>
            </v-autocomplete>
        </div>

        <div class="filter-items">
            <img class="filter-icon" src="../../../../../public/img/calendar_filter.svg" />

            <v-select v-if="dates" :items="Object.values(dates)" v-model="currentFilters.date" item-text="name" item-value="code" class="select">
                <template slot="selection" slot-scope="data">{{ $t(data.item.name) }}</template>
                <template slot="item" slot-scope="data">{{ $t(data.item.name) }}</template>
            </v-select>

            <div class="custom" v-if="currentFilters.date == 'custom'">
                <div class="description">{{ $t('bills.from') }}:</div>
                <input class="date-input" v-model="currentFilters.start_date" type="date" />
                <div class="description">{{ $t('bills.to') }}:</div>
                <input class="date-input" :min="currentFilters.start_date" v-model="currentFilters.end_date" type="date" />
            </div>
        </div>

        <div class="filter-actions">
            <div class="cancel" v-if="JSON.stringify(currentFilters) != JSON.stringify(emptyFilters)" @click="resetFilters()">
                {{ $t('bills.reset_filters') }}
            </div>

            <div class="filter" v-if="changesDetected" @click="applyFilters()">
                {{ $t('bills.filter') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomerFilter',
    data() {
        return {
            currentFilters: {},
            emptyFilters: {
                date: 'month',
                customers: 'admin.filters.all_customers',
                start_date: undefined,
                end_date: undefined
            },
            activeFilters: {},
            changesDetected: false
        }
    },
    computed: {
        dates() {
            return this.$store.getters['customers/getCustomersFilters'].date
        },
        customers() {
            return this.$store.getters['customers/getCustomersFilters'].customers
        }
    },
    methods: {
        resetFilters() {
            this.$overlay.show()
            this.currentFilters = { ...this.emptyFilters }
            this.activeFilters = { ...this.emptyFilters }
            this.$store.commit('customers/setCustomersFiltersActive', this.currentFilters)
            this.$emit('resetFilters')
            this.$overlay.hide()
        },

        applyFilters() {
            this.$overlay.show()
            const payload = { ...this.currentFilters }

            if (payload.date !== 'custom') {
                delete payload.start_date
                delete payload.end_date
            }

            this.$store.commit('customers/setCustomersFiltersActive', payload)
            this.changesDetected = false
            this.activeFilters = JSON.parse(JSON.stringify(payload))
            this.$emit('applyFilters')
            this.$overlay.hide()
        },
    },
    mounted() {
        this.activeFilters = { ...this.$store.getters['customers/getCustomersFiltersActive'] }
        this.currentFilters = { ...this.$store.getters['customers/getCustomersFiltersActive'] }
    },
    watch: {
        currentFilters: {
            handler() {
                this.changesDetected = JSON.stringify(this.currentFilters) != JSON.stringify(this.activeFilters)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss"></style>
